import React from "react";
import { useNavigate } from "react-router-dom";
import OfficerDashboard from "../components/officerDashboard";
import Header from "../components/header";
import Footer from "../components/footer";
import dashboardIcon2 from "../assets/images/grid-view2.png";
import logoutIcon from "../assets/images/logout.svg";
import { useAuth } from "../utils/AuthContext";

const OfficerDesk = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleSignOut = () => {
    ["email", "name", "userId"].forEach((key) => sessionStorage.removeItem(key));
    logout();
    navigate("/");
  };

  return (
    <div className="flex flex-col h-[100dvh] overflow-hidden">
      <Header />
      <div className="flex-1 flex flex-col sm:flex-row overflow-hidden">
        {/* Mobile Top Navigation */}
        <div className="flex sm:hidden w-full bg-page-bg border-b border-cream px-4 py-2 gap-3 justify-between overflow-x-auto shrink-0">
          <div className="flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-semibold shrink-0 whitespace-nowrap bg-brand-teal text-white">
            <img src={dashboardIcon2} alt="" className="w-4 h-4" />
            Dashboard
          </div>
        </div>

        {/* Desktop Sidebar */}
        <div className="hidden sm:flex flex-col w-[250px] min-w-[250px] bg-gradient-to-b from-white to-[#fbeef1] border-r-[1.5px] border-[#e8d3d8] shadow-[2px_0_16px_rgba(74,14,30,0.05)] pt-5 px-4 pb-4 shrink-0 justify-between h-full overflow-y-auto relative z-[5]">
          <div className="flex flex-col gap-[10px] w-full">
            <button
              className="w-full flex items-center gap-[10px] py-[13px] px-[16px] rounded-[8px] font-[700] text-[14px] text-white bg-gradient-to-r from-[#4a0e1e] to-[#9c2942] shadow-[0_4px_14px_rgba(156,41,66,0.3)] border-transparent transition-colors duration-150"
            >
              <i className="fa-solid fa-table-columns w-[16px] text-center"></i>
              Dashboard
            </button>
          </div>

          <div className="flex-1"></div>

          <div className="flex flex-col gap-[10px]">
            <button onClick={handleSignOut} className="w-full flex items-center justify-center gap-[10px] py-[13px] px-[16px] rounded-[8px] font-[700] text-[14px] text-[#9c2942] bg-[#f7eef0] border-[1.5px] border-[#9c2942] hover:bg-[#9c2942] hover:text-white shadow-sm transition-all duration-200 cursor-pointer">
              <i className="fa-solid fa-arrow-right-from-bracket w-[16px] text-center"></i>
              Logout
            </button>
          </div>
        </div>

        {/* Main Content */}
        <main className="flex-1 overflow-y-auto">
          <OfficerDashboard />
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default OfficerDesk;
